import { render, staticRenderFns } from "./CurationPage.vue?vue&type=template&id=9b463e96&scoped=true&"
import script from "./CurationPage.vue?vue&type=script&lang=js&"
export * from "./CurationPage.vue?vue&type=script&lang=js&"
import style0 from "./CurationPage.vue?vue&type=style&index=0&id=9b463e96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b463e96",
  null
  
)

export default component.exports